import {transparentize} from 'polished';
import React, {FC} from 'react';
import styled from 'styled-components';

import {directHoverSelector} from '../../../../../libs/shared/core/src/helpers/browser/hoverHelpers';
import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {Icon} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface JumpToActivityProps {}

/*
 * Style.
 */

const StyledContainerDiv = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 14px;

  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  background: linear-gradient(
    180deg,
    ${(p) => transparentize(0.4, p.theme.foreground)} 0%,
    ${(p) => p.theme.foreground} 100%
  );
  z-index: 1;
  opacity: 0;
  transition: opacity 300ms ease;

  ${directHoverSelector} {
    opacity: 1;
  }
`;

const StyledLabelDiv = styled.div`
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  color: ${(p) => p.theme.interactiveText};
  font-weight: ${fontWeights.semibold};
  font-size: ${fontSizes.verySmall};

  svg {
    transform: rotate(180deg);
  }
`;

/*
 * Component.
 */

export const JumpToActivity: FC<JumpToActivityProps> = (props) => (
  <StyledContainerDiv>
    <StyledLabelDiv>
      <Icon name="arrowThickSmall" />
      <Trans id="annotation-jumptomessage">Jump to message</Trans>
    </StyledLabelDiv>
  </StyledContainerDiv>
);
